module.exports = __webpack_public_path__ + "static/media/img14.2c0ee6ad.JPG";